import React, { useState } from 'react';
import './styles.scss';
import Button from '../../components/Button';
import { Row, Col } from 'antd';
import { useSelector } from 'react-redux';
import { AppState } from '../../store/store';
import { updatePrebidFiles } from "../../api/services/Ascendeum";

const UpdatePrebidFiles: React.FC = () => {
  // Move hook inside component
  const isDarkMode = useSelector((state: AppState) => state.isDarkMode);

  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    setData(null);
    setLoading(true);
    setError(null);
    try {
      const data = await updatePrebidFiles();
      setData(data);
    } catch (error) {
      setError('Invalid JSON response from server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Row className="ascendeum full-width" justify="space-between">
        <Col className="title">
          <div style={{ color: isDarkMode ? '#FDB813' : '#4097FF' }}>
            Update Prebid Files
          </div>
        </Col>
      </Row>

      <Row className="ascendeum full-width" justify="space-between">
        <Col className="buttons">
          <Button
            type="primary"
            title="Update Prebid Files"
            onClick={fetchData}
          />
        </Col>
      </Row>

      <Row className="ascendeum full-width" justify="start">
        <Col span={24}>
          {loading && <div>Updating Prebid Files...</div>}
          {error && <div className="text-red-500">Error: {error}</div>}

          {data && (
            <pre className="bg-gray-100 p-4 rounded overflow-x-auto">
              {JSON.stringify(data, null, 2)}
            </pre>
          )}
        </Col>
      </Row>
    </>
  );
};

export default UpdatePrebidFiles;
